export const useCookies = () => {
  const { gtag } = useGtag()

  // Start as true to ensure no flicker-visibility of cookie banner
  const cookiesEnabled = useState('cookiesEnabled', () => <boolean>true)
  const cookieStatusHasBeenUpdated = useState('cookieStatusHasBeenUpdated', () => <boolean>false)

  const setCookiesEnabled = (value: boolean) => {
    cookieStatusHasBeenUpdated.value = true
    cookiesEnabled.value = value
    localStorage.setItem('ceto-cookies-enabled', value ? 'true' : 'false')
  }

  const resetCookiesState = () => {
    cookiesEnabled.value = false
    cookieStatusHasBeenUpdated.value = false
    localStorage.removeItem('ceto-cookies-enabled')
  }

  onMounted(() => {
    const cookiesEnabledValue = localStorage.getItem('ceto-cookies-enabled')
    if (cookiesEnabledValue) {
      cookiesEnabled.value = JSON.parse(cookiesEnabledValue)
    } else {
      cookiesEnabled.value = false
    }
  })

  watch(cookiesEnabled, (value) => {
    if (value) {
      gtag('consent', 'update', {
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        ad_storage: 'granted',
        analytics_storage: 'granted'
      })
    } else {
      gtag('consent', 'update', {
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        ad_storage: 'denied',
        analytics_storage: 'denied'
      })
    }
  })

  return {
    cookiesEnabled,
    cookieStatusHasBeenUpdated,
    setCookiesEnabled,
    resetCookiesState
  }
}
